import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../../environments/environment.dev';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { BehaviorSubject, catchError, filter, firstValueFrom, map, Observable, of, take } from "rxjs"
import { InteractionStatus } from '@azure/msal-browser';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';


@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  msalService: MsalService = inject(MsalService);
  msalBroadcastService = inject(MsalBroadcastService)
  _errorHandler = inject(ErrorHandlerService)

  /**
     * This BehaviorSubject holds the Account Info of the currently logged in user
     * @private
     * @returns {BehaviorSubject<AccountInfo | undefined>}
     */
  private _activeAccount = new BehaviorSubject<AccountInfo | undefined>(undefined)
  public activeAccount$ = this._activeAccount.asObservable();
  public get hasActiveAccount(): boolean { return this._activeAccount.value != null; };
  public hasActiveAccount$ = this.activeAccount$.pipe(map((account) => account != null))

  constructor() {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        catchError((err) => {
          this._errorHandler.handleError(err)
          return of([])
        })
      )
      .subscribe(() => {
        this._setActiveAccount();
      });
  }

  private _setActiveAccount(): void {

    const accounts = this.msalService.instance.getAllAccounts();
    if (!accounts || accounts.length === 0) {
      return
    }

    this._activeAccount.next(accounts[0])
  }

  public async acquireToken(): Promise<string> {
    const response = await firstValueFrom(
      this.msalService.acquireTokenSilent({
        scopes: ['User.Read'],
        account: this._activeAccount.value
      })
    );
    console.log(response);
    return response.accessToken;
  }


}

